import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UsuarioService } from '../../services/usuario.service';
import { LocalidadEffects } from './localidad.effects';
import { localidadReducer } from './localidad.reducer';
import { LocalidadFeatureKey } from './localidad.state';

@NgModule({
	imports: [
		CommonModule,
		StoreModule.forFeature(LocalidadFeatureKey, localidadReducer),
		EffectsModule.forFeature([LocalidadEffects]),
	],
	providers: [UsuarioService],
})
export class LocalidadStoreModule {}
